import { createAsyncThunk } from '@reduxjs/toolkit'
import { MESSAGES_CONST } from '../../../const/messages-const'
import { CONST } from '../../../const/const'
import { IHorseData } from '../../../models/horse/horse.interface'
import FirestoreService from '../../../services/firestoreService'
import { HorseModel } from '../../../models/horse/horse.model'
import { getConvertedData } from '../../../models/interface.helper'
import { RootState } from '../../store'

const COLLECTIONS = CONST.DATA.FIRESTORE.LATEST.COLLECTIONS

type IGetHorseViaHorseDocIdThunk = {
  req: {
    horseDocId: string
  }
}

const getHorseViaHorseDocIdThunk = createAsyncThunk(
  'getHorseViaHorseDocIdThunk',
  async (payload: IGetHorseViaHorseDocIdThunk['req'], thunkApi) => {
    let message: string | null = null
    let horse: IHorseData | null = null
    let state = thunkApi.getState() as RootState

    try {
      const horseSnapshot = await FirestoreService.getItem(
        COLLECTIONS.HORSES.NAME,
        payload.horseDocId
      )

      if (horseSnapshot.exists()) {
        horse = getConvertedData(HorseModel.fromFirestoreDoc(horseSnapshot).toObject())
      } else {
        throw new Error('Horse not found')
      }

      return {
        horse,
        isMyHorse: state.user.userId === horse.horseOwnerId,
      }
    } catch (error: any) {
      message = error?.message ?? MESSAGES_CONST.SOMETHING_WENT_WRONG
      return thunkApi.rejectWithValue({
        message,
      })
    }
  }
)

export { getHorseViaHorseDocIdThunk }
